export const progression = ['Knowledge', 'Insight', 'Development', 'Better decisions']

export const productFamilies = [
  {
    name: 'Human Capability Platform',
    includes: 'CJI · NCJI',
    link: '/human-capability',
    paragraphs: [
      'CJI and NCJI are frameworks for understanding and developing reasoning, consequential thinking, manipulation resistance, self-direction, cooperation, and leadership responsibility.',
      'The platform is designed to explain findings, guide individual growth, connect strengths with opportunities, and support reassessment over time.',
    ],
  },
  {
    name: 'Semantic Knowledge Platform',
    includes: 'SKP',
    link: '/semantic-knowledge',
    paragraphs: [
      'SKP transforms scattered information into connected knowledge. It brings together structured content, governed vocabularies, knowledge graphs, semantic search, and GraphRAG so people can explore ideas and understand how they relate.',
      'For scientific research, SKP can read a paper and propose connections among organisms, conditions, interventions, study populations, and outcomes. It links each proposal to the relevant passage, matches terms to approved concepts, checks relationships, and sends uncertain or consequential claims to a human reviewer. Approved connections become part of a knowledge graph that researchers can search, question, and build upon.',
      'SKP also supplies the knowledge foundation for CJI and NCJI. It connects capability definitions, assessment tasks, interpretation rules, learning activities, and outcomes, making it possible to understand how a finding or recommendation was produced.',
    ],
  },
]

export const learningCycle = ['Connect knowledge', 'Develop capability', 'Act', 'Learn from the results']

export const approach = [
  {
    title: 'Connect ideas',
    body: 'Organize concepts and relationships so knowledge can move across documents, disciplines, and institutions.',
  },
  {
    title: 'Develop capability',
    body: 'Help people strengthen reasoning and judgment through clear feedback and practical pathways.',
  },
  {
    title: 'Keep decisions reviewable',
    body: 'Make consequential findings understandable, open to correction, and subject to human oversight.',
  },
  {
    title: 'Learn and improve',
    body: 'Use outcomes to refine both the knowledge system and the programs built upon it.',
  },
]
